import { useRouteContext } from '@tanstack/react-router';

import type { RouterContext } from './router-context';

/** The session, the account API and the site's configuration (the router's context). */
export function useSite(): RouterContext {
  return useRouteContext({ from: '__root__' });
}
